import { render, staticRenderFns } from "./MessageTypeTable.vue?vue&type=template&id=6b7f82c2&"
import script from "./MessageTypeTable.vue?vue&type=script&lang=js&"
export * from "./MessageTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports